import { jsxs as x, jsx as I } from "react/jsx-runtime";
import { ChevronRightIcon as l, ChevronDownIcon as h } from "../../../icons/index.es.js";
import { Button as g } from "../../../atoms/Button/Button.es.js";
import { Box as w } from "@chakra-ui/react";
import { useDropdownContext as D, useDropdownStyle as _ } from "../Dropdown.context.es.js";
const R = ({ children: s, trackId: d, ...e }) => {
  const {
    activeIndex: F,
    buttonRef: a,
    getItemProps: u,
    getReferenceProps: r,
    hasFocusInside: c,
    isNested: o,
    isOpen: m,
    item: b,
    parent: f,
    setHasFocusInside: v
  } = D(), n = _();
  return o ? /* @__PURE__ */ x(
    w,
    {
      ...e,
      as: "button",
      __css: { ...n.item, ...n.buttonItem },
      "data-focus-inside": c ? "" : void 0,
      "data-nested": o ? "" : void 0,
      "data-open": m ? "" : void 0,
      ref: a,
      role: "menuitem",
      tabIndex: F === b.index ? 0 : -1,
      "track-id": d,
      ...r(
        u({
          onFocus(i) {
            var t;
            (t = e.onFocus) == null || t.call(e, i), v(!1), f.setHasFocusInside(!0);
          }
        })
      ),
      children: [
        s,
        /* @__PURE__ */ I(l, { marginLeft: "auto", boxSize: 4 })
      ]
    }
  ) : /* @__PURE__ */ x(
    g,
    {
      __css: n.button,
      variant: "tertiary",
      "data-nested": o ? "" : void 0,
      "data-open": m ? "" : void 0,
      "data-focus-inside": c ? "" : void 0,
      ref: a,
      role: o ? "menuitem" : void 0,
      size: "md",
      "track-id": d,
      ...e,
      ...r(
        u({
          onFocus(i) {
            var t;
            (t = e.onFocus) == null || t.call(e, i), v(!1), f.setHasFocusInside(!0);
          }
        })
      ),
      children: [
        s,
        /* @__PURE__ */ I(h, { boxSize: 4 })
      ]
    }
  );
};
export {
  R as DropdownButton
};
//# sourceMappingURL=DropdownButton.es.js.map
